<template>
  <fieldset>
    <!-- edit mode -->
    <div class="switch">
      <input
        :id="name + '-choice_' + options[0].Text.toLowerCase()"
        :key="loading || disabled ? 'disabled-0' : 'enabled-0'"
        v-model="model"
        :value="options[0]"
        :name="name + '-likeme_choice'"
        :disabled="loading || disabled"
        type="radio"
        class="switch-input"
        :data-test="name + '-choice_' + options[0].Text.toLowerCase()"
        @click="$emit('update:modelValue', options[0])"
      />
      <label
        :for="name + '-choice_' + options[0].Text.toLowerCase()"
        :data-test-selected="isSelected(options[0])"
        class="switch-label switch-label-left"
      >
        {{ options[0].Text }}
      </label>
      <input
        :id="name + '-choice_' + options[1].Text.toLowerCase()"
        :key="loading || disabled ? 'disabled-1' : 'enabled-1'"
        v-model="model"
        :value="options[1]"
        :name="name + '-likeme_choice'"
        :disabled="loading || disabled"
        type="radio"
        class="switch-input"
        :data-test="name + '-choice_' + options[1].Text.toLowerCase()"
        @click="$emit('update:modelValue', options[1])"
      />
      <label
        :for="name + '-choice_' + options[1].Text.toLowerCase()"
        :data-test-selected="isSelected(options[1])"
        class="switch-label switch-label-right"
      >
        {{ options[1].Text }}
      </label>
      <span class="selection-indicator" />
    </div>
  </fieldset>
</template>

<script>
import FormComponentMixin from './_FormComponentMixin';

export default {
  name: 'ButtonSwitch',
  mixins: [FormComponentMixin],
  props: {
    modelValue: {
      type: Object,
      default() {
        return { Text: 'Nej', Value: false };
      }
    },
    options: {
      type: Array,
      default() {
        return [
          { Text: 'Ja', Value: true },
          { Text: 'Nej', Value: false }
        ];
      }
    }
  }
};
</script>
